import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Close } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

type ExcludedHousesData = {
    auctionHouseName: string;
    sellerId: number;
};

type ExcludedHousesTableProps = {
    className?: string;
    houseData: ExcludedHousesData[];
    onRemoveHouse: (sellerId: number) => void;
};

export const ExcludedHousesTable = ({ className, houseData, onRemoveHouse }: ExcludedHousesTableProps) => {
    return (
        <div className={cn('overflow-hidden rounded-md border border-border-secondary', className)}>
            <div className="border-b border-border-primary px-sm py-2xs">
                <LabelStrong>
                    <FormattedMessage
                        id="excludeAuctionHousesFilter.modal.excludedHousesTable.title"
                        values={{ count: houseData.length }}
                    />
                </LabelStrong>
            </div>
            <div className="relative max-h-[190px] [scrollbar-width:none] overflow-y-auto [-ms-overflow-style:none] [&::-webkit-scrollbar]:w-0 hover:[&::-webkit-scrollbar]:w-2 hover:[&::-webkit-scrollbar-thumb]:bg-border-secondary">
                {!houseData.length && (
                    <div className="px-sm py-xs">
                        <BodySecondary>
                            <FormattedMessage id="excludeAuctionHousesFilter.modal.excludedHousesTable.noExclusions" />
                        </BodySecondary>
                    </div>
                )}
                {houseData.map((item) => (
                    <div
                        className="flex items-center justify-between border-b border-border-secondary px-sm last:border-b-0 hover:bg-background-secondary"
                        key={item.sellerId}
                    >
                        <BodySecondary className="max-w-[240px] truncate text-left">
                            {item.auctionHouseName}
                        </BodySecondary>
                        <IconButton
                            icon={Close}
                            onClick={() => onRemoveHouse(item.sellerId)}
                            size="sm"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};
